import { render, staticRenderFns } from "./MultiSimpleKeyboard.vue?vue&type=template&id=5f2aab69&scoped=true&"
import script from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./MultiSimpleKeyboard.vue?vue&type=style&index=0&id=5f2aab69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2aab69",
  null
  
)

export default component.exports